import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon, Text } from 'components/elements';
import * as S from './styles';

function IconCard({ iconName, iconColour, text, textColour }) {
  return (
    <S.IconCard label="IconCard">
      <SvgIcon name={iconName} color={iconColour} />
      <Text variant="label" colour={textColour}>
        {text}
      </Text>
    </S.IconCard>
  );
}

IconCard.defaultProps = {
  iconColour: 'primary.700',
  textColour: 'primary.700',
};

IconCard.propTypes = {
  iconName: PropTypes.string.isRequired,
  iconColour: PropTypes.string,
  text: PropTypes.string.isRequired,
  textColour: PropTypes.string,
};

export default IconCard;
